import collection from './exam/collection';
import item from './exam/item';

const exam = {
  namespaced: true,
  modules: {
    collection,
    item,
  },
};

export default exam;
